import { IQuery } from 'core-ts-types';
import { IContentTileExpectedObj, IContentTileTextObj } from 'ui-ng-content-tile';
import { IDatasource, Query } from 'utility-ts-orm';
import { PathItem } from './../builders/path_item_builder';
import { PathTask } from './../builders/path_task_builder';

export class AppointmentPriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj;
  private _count: number;

  constructor(private ngPathItemDatastore: IDatasource<PathItem>, private ngPathTaskDatastore: IDatasource<PathTask>) {
    Query.registerQuery(this, this.ngPathItemDatastore, this.ngPathTaskDatastore);
  }

  private __isToday(time: moment.Moment) {
    const today = moment();
    return time.isBefore(today.endOf('day')) && time.isAfter(today.startOf('day'));
  }

  private __iPriorityFeedObjBuilder(currentTasks: PathTask[]) {
    const currentTask = _.first(currentTasks);
    let time = '';
    if (!_.isEmpty(currentTask)) {
      time =
        !_.isEmpty(currentTask.start_ts) && currentTask.start_ts.isValid()
          ? currentTask.start_ts.format('h:mma')
          : currentTask.end_ts.format('h:mma');
    }
    const title =
      currentTasks.length === 1 ? 'Advisor Appointment' : `You have ${currentTasks.length} appointments today`;
    const subTitle = currentTasks.length === 1 ? `Today at ${time}` : 'Check them out';
    const action =
      currentTasks.length === 1
        ? {
            state: 'my.todos.appointment',
            params: {
              eventId: currentTask.event,
              repeatedBy: currentTask.repeated_by
            }
          }
        : { state: 'my.myAppointments' };
    return { text: { title, subTitle }, action };
  }

  run(): this {
    const apptTask = _.first(this.ngPathItemDatastore.query((item) => item.presenter === 'APPOINTMENT'));
    const currentTasks = this.ngPathTaskDatastore.query((task) => {
      return task.item === _.get(apptTask, 'id') && (this.__isToday(task.start_ts) || this.__isToday(task.end_ts));
    });
    this._count = currentTasks.length;
    const isActive = currentTasks.length > 0;
    const { action, text } = this.__iPriorityFeedObjBuilder(currentTasks);
    this._result = {
      icon: { type: 'calender', theme: 'magenta' },
      action,
      text,
      isOverdue: false,
      isActive
    };

    return this;
  }

  get count() {
    return this._count;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/queries/appointments_priority_feed_query.ts